import React, { useEffect, useState } from "react";
import {
  getAllRestaurants,
  updateRoomFeature,
  updateStoreInventoryFeature,
  updatemobileFeature,
} from "../../utils/superAdminApi";

export default function SuperAdminAccess() {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState({});

  useEffect(() => {
    fetchRestaurants();
  }, []);

  async function fetchRestaurants() {
    setLoading(true);
    setError(null);
    try {
      const data = await getAllRestaurants();
      setRestaurants(data.restaurants);
    } catch (err) {
      setError("Failed to load restaurants");
    }
    setLoading(false);
  }

  async function handleToggleRoomFeature(id, enabled) {
    setUpdating((prev) => ({ ...prev, [id]: true }));
    try {
      await updateRoomFeature(id, enabled);
      setRestaurants((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, roomFeatureEnabled: enabled } : r
        )
      );
    } catch (err) {
      alert("Failed to update room feature");
    }
    setUpdating((prev) => ({ ...prev, [id]: false }));
  }

  async function handleToggleStoreInventoryFeature(id, enabled) {
    setUpdating((prev) => ({ ...prev, [`${id}-inventory`]: true }));
    try {
      await updateStoreInventoryFeature(id, enabled);
      setRestaurants((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, storeInventoryEnabled: enabled } : r
        )
      );
    } catch (err) {
      alert("Failed to update store inventory feature");
    }
    setUpdating((prev) => ({ ...prev, [`${id}-inventory`]: false }));
  }
  async function handleTogglemobileFeature(id, enabled) {
    setUpdating((prev) => ({ ...prev, [`${id}-mobile-version`]: true })); // ✅ use proper key
    try {
      await updatemobileFeature(id, enabled);
      setRestaurants((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, mobileViewEnabled: enabled } : r
        )
      );
    } catch (err) {
      alert("Failed to update mobile feature");
    }
    setUpdating((prev) => ({ ...prev, [`${id}-mobile-version`]: false })); // ✅ match key
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-white mb-6">Access Management</h1>
      <div className="bg-gray-800 p-8 rounded-lg text-center text-gray-400">
        <p>
          Manage super admin and staff access here. Toggle the Room Feature and
          Store Inventory for each restaurant below.
        </p>
      </div>
      <div className="mt-8">
        {loading ? (
          <div className="text-center text-gray-400">Loading...</div>
        ) : error ? (
          <div className="text-center text-red-400">{error}</div>
        ) : (
          <table className="min-w-full bg-gray-800 rounded-lg overflow-hidden mt-4">
            <thead>
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Restaurant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Room Feature
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Store Inventory
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                  Mobile View
                </th>
              </tr>
            </thead>
            <tbody>
              {restaurants.map((r) => (
                <tr key={r.id} className="border-b border-gray-700">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                    {r.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button
                      className={`px-4 py-2 rounded-lg font-bold ${
                        r.roomFeatureEnabled
                          ? "bg-green-600 text-white"
                          : "bg-gray-600 text-gray-200"
                      } ${updating[r.id] ? "opacity-50 cursor-wait" : ""}`}
                      onClick={() =>
                        handleToggleRoomFeature(r.id, !r.roomFeatureEnabled)
                      }
                      disabled={updating[r.id]}
                    >
                      {r.roomFeatureEnabled ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button
                      className={`px-4 py-2 rounded-lg font-bold ${
                        r.storeInventoryEnabled
                          ? "bg-green-600 text-white"
                          : "bg-gray-600 text-gray-200"
                      } ${
                        updating[`${r.id}-inventory`]
                          ? "opacity-50 cursor-wait"
                          : ""
                      }`}
                      onClick={() =>
                        handleToggleStoreInventoryFeature(
                          r.id,
                          !r.storeInventoryEnabled
                        )
                      }
                      disabled={updating[`${r.id}-inventory`]}
                    >
                      {r.storeInventoryEnabled ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button
                      className={`px-4 py-2 rounded-lg font-bold ${
                        r.mobileViewEnabled
                          ? "bg-green-600 text-white"
                          : "bg-gray-600 text-gray-200"
                      } ${
                        updating[`${r.id}-mobile-version`]
                          ? "opacity-50 cursor-wait"
                          : ""
                      }`}
                      onClick={() =>
                        handleTogglemobileFeature(r.id, !r.mobileViewEnabled)
                      }
                      disabled={updating[`${r.id}-mobile-version`]}
                    >
                      {r.mobileViewEnabled ? "Active" : "Inactive"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
